export default "__VITE_ASSET__D8HM4W3w__"